import CalendlyEvent from './CalendlyEvent';

export default CalendlyEvent;
